import r_code from '../src/utils/r_code'
import axios from 'axios'
import store from '../src/store'
export default {
    getUrlKey: function (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    },
    h_Ajax(path, type, params, headers, data_type, success_callback, error_callback) {
        console.log(params)
        var send_data = {
            url: path,
            method: type,
            headers: headers,
        };
        if (type == "get") {
            send_data.params = params;
        } else if (type == "post") {
            send_data.data = params;
        };
        axios(send_data)
            .then(res => {
                if (data_type == 1) {
                    success_callback(res.data.data);
                } else if (data_type == 2) {
                    success_callback(res.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                error_callback(error);
            });
    },
    echart_font(font_size) {
        var clientWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        if (!clientWidth) return;
        // console.log("clientWidth=" + clientWidth);
        if (clientWidth <= 1450) {
            clientWidth = 1450;
        }
        let fontSize = clientWidth / 100;
        return font_size * fontSize;
    },

    //获取token的 ajax 调用
    h_Ajax_token(path, type, params, headers, data_type, success_callback, error_callback) {
        if (!headers.token) {
            console.log('调用store token');
            var lasmsUserInfo = store.getters.getlasmsUserInfo();
            if(!lasmsUserInfo){
                error_callback();
                return false;
            }
            var user_model = JSON.parse(lasmsUserInfo);
         
            headers.token = user_model.token;
        }
        var send_data = {
            url: path,
            method: type,
            headers: headers,
        };
        if (type == "get") {
            send_data.params = params;
        } else if (type == "post"||type=="patch") {
            send_data.data = params;
        };
        axios(send_data)
            .then(res => {
                if (data_type == 1) {
                    success_callback(res.data.data);
                } else if (data_type == 2) {
                    success_callback(res.data);
                }
            })
            .catch(function (error) {
                console.log(error);
                error_callback(error);
            });
    },


}